import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IBroadcast } from '../types/IBroadcast';

export interface IGetDetailBroadcastParams {
    viewLuid: string;
}

export interface IGetDetailBroadcastResult extends IBroadcast, IResult {
    //TODO: TFS 1446186 - add timestamp for Synchronization check of broadcast view
}

export class GetDetailOfABroadcastRequest extends Request<IGetDetailBroadcastParams, IGetDetailBroadcastResult> {
    constructor(params: IGetDetailBroadcastParams) {
        super('getBroadcastView', params);
    }
}